import { ActivityList } from "@entities/activity/ui/ActivityList/ActivityList";
import useGetOrganisationById from "@entities/organisation/lib/hooks/useGetOrganisationById";
import { EmployeesTab } from "@entities/organisation/ui/EmployeesTab";
import { SettingsTab } from "@entities/organisation/ui/SettingsTab";
import { TeamTab } from "@entities/organisation/ui/TeamTab";
import { AdRightsTab } from "@widgets/AdRightsTab";
import { Flex, Spin, Tabs, Tag } from "antd";
import { FileText, Megaphone, Settings, Users } from "lucide-react";
import styles from "./OrganisationDetails.module.scss";

export const OrganisationDetails = ({
  organisationId,
}: {
  organisationId: string;
}) => {
  const { organisation, isLoading, refetchOrganisationById } =
    useGetOrganisationById(organisationId);

  return (
    <Spin spinning={isLoading}>
      <Flex vertical>
        <Tabs className={styles.tabs}>
          <Tabs.TabPane
            tab={
              <span className={styles.tabLink}>
                <Settings size={16} /> Settings
              </span>
            }
            key="1"
          >
            <SettingsTab
              organisation={organisation}
              refetchOrganisationById={refetchOrganisationById}
              organisationId={organisationId}
            />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span className={styles.tabLink}>
                <Users size={16} /> Employees
                <Tag className={styles.tag}>
                  {
                    organisation?.permission?.filter(
                      (item) => item.userType === "brand-user"
                    ).length
                  }
                </Tag>
              </span>
            }
            key="2"
          >
            <EmployeesTab
              organisation={organisation}
              organisationId={organisationId}
            />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span className={styles.tabLink}>
                <Users size={16} /> Team
                <Tag className={styles.tag}>
                  {
                    organisation?.permission?.filter(
                      (item) => item.userType !== "brand-user"
                    ).length
                  }
                </Tag>
              </span>
            }
            key="3"
          >
            <TeamTab
              organisation={organisation}
              organisationId={organisationId}
            />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span className={styles.tabLink}>
                <Megaphone size={16} /> Ad Rights Settings
              </span>
            }
            key="4"
          >
            <div style={{ padding: 20 }}>
              <AdRightsTab brandOrganisationId={organisationId} />
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span className={styles.tabLink}>
                <FileText size={16} /> Activity Log
              </span>
            }
            key="5"
          >
            <div style={{ padding: 20 }}>
              <ActivityList
                datePosition="start"
                brandOrganisationId={organisationId}
              />
            </div>
          </Tabs.TabPane>
        </Tabs>
      </Flex>
    </Spin>
  );
};
